// extracted by mini-css-extract-plugin
export default {"container":"TableRowColumn__container-mPUXc"};